import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group, GroupMembership } from "@shared/models/group"
import type NotifierService from "cc-frontend/services/notifier"
import type Rpc from "cc-frontend/services/rpc"
import { includes } from "lodash-es"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    row: GroupMembership
    group: Group
  }
}

export default class GroupMembersTableActionsCellAdmin extends Component<Signature> {
  @service declare rpc: Rpc
  @service declare notifier: NotifierService

  @tracked isHovering = false
  @tracked isExecutingRpc = false

  @action mouseEnter() {
    this.isHovering = true
  }

  @action mouseLeave() {
    this.isHovering = false
  }

  get isAdmin() {
    return includes(get(this.args.row.attributes, "roles"), "group:is-admin")
  }

  @action
  changeRole() {
    this.isHovering = false
    this.isExecutingRpc = true

    let newRole: "group:is-member" | "group:is-admin" = this.isAdmin
      ? "group:is-member"
      : "group:is-admin"

    this.rpc
      .group_set_member_role({
        groupId: this.args.group.id,
        membershipId: this.args.row.id,
        role: newRole,
      })
      .then((response) => {
        if (this.isDestroyed || this.isDestroying) {
          return
        } else {
          this.isExecutingRpc = false
          if (response.responseOk === false) {
            if (response.result.code === "NO_ADMIN_SEATS_AVAILABLE") {
              this.notifier.warning("", {
                notificationId: response.result.code,
                title: `There are no more admin seats available`,
                message: "Contact support@commoncurriuclum.com to request an upgrade",
                duration: 5000,
                type: "is-processing",
              })
            }
          }
        }
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::ActionsChangeRole": typeof GroupMembersTableActionsCellAdmin
  }
}
